import moment from "moment";
export default class Format{
    date = (date, format: string = "YYYY-MM-DD") => {
        if (!date) return "";
        format = format.toUpperCase()
    
        return moment(date).format(format);
    }

    amount = (value, precision: number = 2) => {
        if (!value && value !== 0) return "";

        let floatValue = parseFloat(value)
        value = floatValue.toFixed(precision)

        //value = value.toString();
        let valueArr = value.split('.');
        let intPart = valueArr[0]; //获取整数部分
        let intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); //将整数部分逢三一断
        let floatPart = "";
        if (valueArr.length == 2) {
            floatPart = valueArr[1].toString(); //拿到小数部分

            // if (Number(floatPart) == 0) {
            //     floatPart = "0".repeat(precision);
            // }

            return intPartFormat + "." + floatPart;
        } else {
            return intPartFormat + "0".repeat(precision);
        }
    }

    dateRange(fromDate: string, toDate: string, format: string = "YYYY-MM-DD"): string {
        if (!fromDate || !toDate) {
            return '';
        }
        return this.date(fromDate, format) + '~' + this.date(toDate, format);
    }
}